var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.135 0C26.43 0 30 3.4065 30 8.49V21.495C30 26.58 26.43 30 21.135 30H8.88C3.57 30 0 26.58 0 21.495V8.49C0 3.4065 3.57 0 8.88 0H21.135ZM15.315 8.58C14.88 8.145 14.16 8.145 13.725 8.58L8.07 14.205C7.65 14.625 7.65 15.375 8.07 15.795L13.725 21.42C14.16 21.855 14.88 21.855 15.315 21.42C15.75 20.97 15.75 20.265 15.315 19.815L11.595 16.125H21.12C21.75 16.125 22.245 15.615 22.245 15C22.245 14.37 21.75 13.875 21.12 13.875H11.595L15.315 10.17C15.525 9.96 15.645 9.66 15.645 9.375C15.645 9.0915 15.525 8.805 15.315 8.58Z",
    fill: "#08296B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.1f4e3f7c2dedd9e667ac0334ecc7173a.svg";
export { ForwardRef as ReactComponent };